import React, { useState, useEffect } from 'react';
import './Steps.css';

function Step2({ onNext }) {
  const [progress, setProgress] = useState(0);
  const [showResult, setShowResult] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => setShowResult(true), 500);
          return 100;
        }
        return prev + 2;
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="step-container">
      <div className="step-content">
        <div className="emoji-large">💕</div>
        <h1 className="step-title">Step 2 – Memory Scan</h1>
        <h2 className="heading">📸 Scanning Memories...</h2>
        
        {!showResult ? (
          <>
            <p className="text">Analyzing our chats…</p>
            <p className="text">Analyzing our laughs…</p>
            <p className="text">Analyzing the way you smile…</p>
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${progress}%` }}>
                {progress}%
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="result-box">
              <p className="result-text">Result: 100% Happiness Found Because of You.</p>
            </div>
            <button className="btn btn-primary" onClick={onNext}>
              ➡ Continue
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Step2;